import React from 'react'
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import ProjectDeptCountContainer from '../../containers/project_dept_count/ProjectDeptCountContainer';


const ProjectDeptCountViewPage = () => {
    return (
        <div>
            <BreadcrumbsContainer title="통계/수주관리/포캐스팅 등록 현황" icon="statistics" />
            <ProjectDeptCountContainer />
        </div>
    )
}

export default ProjectDeptCountViewPage